import React from 'react';
import { Grip, CircleUserRound, Puzzle, Clock, Users, Boxes, KeyRound, LifeBuoy } from 'lucide-react';

// THE GLYPHS — one per section, used everywhere a section is drawn: the rail,
// the vault on Home, and anything else that names a section. The open drawings
// closest to the Mac's SF Symbols (owner call 2026-09-30: SF stays on the Mac);
// where lucide has none close enough, the figure is drawn here. Every glyph
// takes `size`, `strokeWidth`, and passes the rest (x, y, className) through,
// so it can stand inside another SVG.
const stroke = { fill: 'none', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' };

// circle.circle: a ring inside a ring — the realm, the gate
export const CircleCircle = ({ size = 15, strokeWidth = 1.5, ...rest }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} strokeWidth={strokeWidth} aria-hidden="true" {...rest}>
        <circle cx="12" cy="12" r="9.5" /><circle cx="12" cy="12" r="5" />
    </svg>
);
// circle.hexagongrid: seven dots, one and the six around it — the identity graph
export const CircleHexagonGrid = ({ size = 15, strokeWidth = 1.5, ...rest }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} strokeWidth={strokeWidth} aria-hidden="true" {...rest}>
        {[[12, 12], [12, 4.6], [12, 19.4], [5.6, 8.3], [18.4, 8.3], [5.6, 15.7], [18.4, 15.7]].map(([x, y]) => <circle key={`${x}${y}`} cx={x} cy={y} r="2.4" />)}
    </svg>
);

export const GLYPHS = {
    self: CircleUserRound, graph: CircleHexagonGrid, realms: CircleCircle, apps: Grip,
    plugins: Puzzle, people: Users, groups: Boxes, access: KeyRound, activity: Clock, help: LifeBuoy,
};

// A section's glyph by its glyph id (map.js `glyph`), null when it has none.
export function Glyph({ name, ...props }) {
    const G = GLYPHS[name];
    return G ? <G {...props} /> : null;
}
